import { Loader2Icon } from "lucide-react";

export default function Loader() {
  return <Loader2Icon className="size-10 animate-spin" />;
}
